/* eslint-disable  */
import * as React from "react";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
// import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Stack, Modal } from "@mui/material";
// import VehicleForm from "./vehicle";
// import { default as VehicleList } from "./vehiclelist";
// import Switch from "@mui/material/Switch";
// import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";
import { get } from "../library/Api";
import { post } from "../library/Api";
import EditvehicleForm from "./vehicleEditForm";
import { buildVehiclePayload } from "../helpers/vehicleHelpers";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { remove } from "../library/Api";
// import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";
import EditIcon from "@mui/icons-material/Edit";
import DataTable from "react-data-table-component";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Select from "react-select";
import WarningIcon from "../assets/images/warning.svg";
import PulseLoader from "react-spinners/PulseLoader";
// import PhoneInput from "react-phone-number-input";
// const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  // '& .MuiDialog-paperWidthSm': {
  //   maxWidth: '800',
  // },
  "& .MuiTextField-root": {
    width: "48%",
  },
  // '& .MuiBox-root' : {
  //   textAlign: 'center',
  // },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

// const IOSSwitch = styled((props) => (
//   <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
// ))(({ theme }) => ({
//   width: 42,
//   height: 26,
//   padding: 0,
//   "& .MuiSwitch-switchBase": {
//     padding: 0,
//     margin: 2,
//     transitionDuration: "300ms",
//     "&.Mui-checked": {
//       transform: "translateX(16px)",
//       color: "#fff",
//       "& + .MuiSwitch-track": {
//         backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
//         opacity: 1,
//         border: 0,
//       },
//       "&.Mui-disabled + .MuiSwitch-track": {
//         opacity: 0.5,
//       },
//     },
//     "&.Mui-focusVisible .MuiSwitch-thumb": {
//       color: "#33cf4d",
//       border: "6px solid #fff",
//     },
//     "&.Mui-disabled .MuiSwitch-thumb": {
//       color:
//         theme.palette.mode === "light"
//           ? theme.palette.grey[100]
//           : theme.palette.grey[600],
//     },
//     "&.Mui-disabled + .MuiSwitch-track": {
//       opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
//     },
//   },
//   "& .MuiSwitch-thumb": {
//     boxSizing: "border-box",
//     width: 22,
//     height: 22,
//   },
//   "& .MuiSwitch-track": {
//     borderRadius: 26 / 2,
//     backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
//     opacity: 1,
//     transition: theme.transitions.create(["background-color"], {
//       duration: 500,
//     }),
//   },
// }));

const CustomerEditforms = ({ theEmployee, theEmployees, onClose }) => {
  const [name, setName] = useState(theEmployee.firstName || "");
  const [lastName, setLastName] = useState(theEmployee.lastName || "");
  const [email, setEmail] = useState(theEmployee.email || "");
  const [phone, setPhone] = useState(theEmployee.mobile || "");
  const [regdate, setRegdate] = useState(theEmployee.regdate || "");
  const [account, setAccount] = useState(theEmployee.account || "");
  const [no_vehicle, setVehicle] = useState(theEmployee.vehicles || "0");
  const [capacity_vehicle, setCapacityVehicle] = useState(0);
  const [existing_vehicle, setexistingVehicle] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [customer_id, setCustomer_id] = useState(theEmployee.customer_id || "");
  const [tp_id, settp_id] = useState(theEmployee.tp_id || "");
  const [tp_credentialid, setcredentialId] = useState(
    theEmployee.tp_credentialid || ""
  );
  const [tp_groupid, settpGroupid] = useState(theEmployee.tp_groupid || "");

  const [companyList, setCompanyList] = useState([]);

  const [formData, setFormData] = useState([]);
  const [licensePlateSpaceError, setLicensePlateSpaceError] = useState({});

  const [profile, setProfile] = useState(theEmployee.profile || "");
  const [company, setCompany] = useState(theEmployee.company || "");
  const [facilityCode, setfacilityCode] = useState(
    theEmployee.facility_code || ""
  );
  const [cardId, setcardId] = useState(theEmployee.facilityCode || "");
  const [rfid, setRfid] = useState(theEmployee.rfid || "");
  const [building, setBuilding] = useState(
    theEmployee.building || "250  Assay Street"
  );
  const [accessGroup, setAccessGroup] = useState(
    [{ label: "Admin", value: "Admin" }] || ""
  );
  // const [room, setRoom] = useState(theEmployee.room || "");
  const [addoption, setAddOPtion] = useState(false);
  const [garage, setGarage] = useState(theEmployee.garage || "Garage Address");

  const [disablemode, setDisable] = useState(false);
  const [show, setShow] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [optionSelected, setOptionselected] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [optionroom, setOptionroom] = useState([]);
  const [optionrooms, setOptionrooms] = useState([]);
  const [rfidCheckModal, setrfidCheckModal] = useState(false);
  const [rfidDetails, setRfidDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rfidWarningModal, setRfidWarningModal] = useState(false);
  const [requiresGarageAccess, setRequiresGarageAccess] = useState(false);
  const [isVehicleLoading, setIsVehicleLoading] = useState(false);
  // const opt = [];
  const access_group_options = [
    { label: "Admin", value: "Admin" },
    { label: "All Access", value: "All Access" },
    { label: "Men's Room", value: "Men's Room" },
    { label: "Women's Room", value: "Women's Room" },
    { label: "Suite 301", value: "Suite 301" },
    { label: "Trash Rm.", value: "Trash Rm." },
    { label: "Apache", value: "Apache" },
    { label: "Caprock", value: "Admin" },
    { label: "Lilly Access", value: "Lilly Access" },
    { label: "McCord", value: "McCord" },
    { label: "Nimble", value: "Nimble" },
    { label: "Hunter", value: "Hunter" },
  ];
  const [selectedAccessgroups, setSelectedAccessGroups] = useState(
    access_group_options.filter((item) =>
      theEmployee?.access_group?.includes(item.label)
    ) || ""
  );
  const options = [
    { label: "Rm.307", value: "1" },
    { label: "Rm.308", value: "2" },
    { label: "Rm.309", value: "3" },
    { label: "Rm.310", value: "4 " },
    { label: "Rm.311", value: "5" },
    { label: "Rm.312", value: "6" },
    { label: "Rm.313", value: "7" },
    { label: "Rm.314", value: "8" },
    { label: "Rm.315", value: "9" },
    { label: "Rm.316", value: "10" },
    { label: "Rm.317", value: "11" },
    { label: "Rm.318", value: "12" },
    { label: "Rm.319", value: "13" },
    { label: "Rm.320", value: "14" },
    { label: "Rm.321", value: "15" },
    { label: "Rm.322", value: "16" },
    { label: "Rm.323", value: "17" },
    { label: "Rm.324", value: "18" },
    { label: "Rm.325", value: "19" },
    { label: "Rm.326", value: "20" },
    { label: "Rm.327", value: "21" },
    { label: "Rm.328", value: "22" },
    { label: "Rm.333", value: "23" },
    { label: "Rm.335", value: "24" },
    { label: "Rm.336", value: "25" },
    { label: "Rm.337", value: "26" },
    { label: "Rm.338", value: "27" },
    { label: "Rm.339", value: "28" },
    { label: "Rm.340", value: "29" },
    { label: "Rm.342", value: "30" },
    { label: "Rm.343", value: "31" },
    { label: "Rm.344", value: "32" },
    { label: "Rm.345", value: "33" },
    { label: "Rm.346", value: "34" },
    { label: "Rm.347", value: "35" },
    { label: "Rm.348", value: "36" },
    { label: "Rm.350", value: "37" },
    { label: "Rm.351", value: "38" },
    { label: "Rm.352", value: "39" },
    { label: "Rm.353", value: "40" },
    { label: "Rm.354", value: "41" },
    { label: "Rm.355", value: "42" },
    { label: "Rm.356", value: "43" },
    { label: "Rm.357", value: "44" },
    { label: "Rm.358", value: "45" },
    { label: "Rm.359", value: "46" },
    { label: "Rm.360", value: "47" },
    { label: "Rm.361", value: "48" },
    { label: "Rm.362", value: "49" },
  ];
  const [opt, setOpt] = useState(
    options.filter((item) => theEmployee?.room?.includes(item.label))
  );
  // var sample=options.filter((item) => theEmployee?.room?.includes(item.label));
  // setRooms(sample);
  const [admin_id, setadmin_id] = useState("");
  const [res, setRes] = useState([]);

  const optionss = [
    { label: "Rm.307", value: "1" },
    { label: "Rm.308", value: "2" },
  ];

  const [datas, setDatas] = useState([]);
  const myNewTheme = {
    rows: {
      fontSize: "50px",
    },
  };
  // const history = useHistory();
  const navigate = useNavigate();

  // const [formData, setFormData] = useState([])
  // useEffect(() => {
  // var optp= options.filter((item) => theEmployee?.room?.includes(item.label));
  // setOpt(optp);
  console.log("ressssssss", opt);
  // console.log("resactual", optp);
  // }, [opt]);
  useEffect(() => {
    console.log("customerid = ", theEmployee);
    setName(theEmployee.firstName || "");
    setLastName(theEmployee.lastName || "");
    setEmail(theEmployee.email || "");
    setPhone(theEmployee.mobile || "");
    setVehicle(theEmployee.vehicles || "0");
    setIsSubmitted(false);
    setCustomer_id(theEmployee.customer_id || "");
    setRegdate(theEmployee.regdate || "");
    setAccount(theEmployee.account || "");
    setfacilityCode(theEmployee.facilityCode || "");
    // setAccessGroup(theEmployee.access_group || "");
    setAccessGroup([{ label: "Admin", value: "Admin" }] || "");
    setBuilding(theEmployee.building || "");
    // console.log("-=================---reg Date --- >",theEmployee.regdate)
    setProfile(theEmployee.profile || "");
    setCompany(theEmployee.company || "");
    setRfid(theEmployee.rfid || "");
    settp_id(theEmployee.tp_id || "");
    setcredentialId(theEmployee.tp_credentialid || "");
    settpGroupid(theEmployee.tp_groupid || "");
    if (theEmployee.rfid) {
      const myArray = theEmployee.rfid.split(":");
      setfacilityCode(myArray[0] || "");
      setcardId(myArray[1] || "");
    }
    // setRoom(theEmployee.room || "");
    console.log(theEmployee.room);
    setGarage(theEmployee.garage || "");
    setOpt(options.filter((item) => theEmployee?.room?.includes(item.label)));
    setSelectedOptions(
      options.filter((item) => theEmployee?.room?.includes(item.label))
    );
    setSelectedAccessGroups(
      access_group_options.filter((item) =>
        theEmployee?.access_group?.includes(item.label)
      )
    );

    get(`get_company_list`).then((res) => {
      // const data = res;
      setCompanyList(res.data.companies);
    });
  }, [theEmployee]);

  useEffect(() => {
    var mcdata = JSON.parse(localStorage.getItem("MCData"));
    var tempadmin_id = mcdata.admin_id;
    setadmin_id(tempadmin_id);
  }, []);

  const states = [
    { label: "Alabama (AL)", value: "Alabama", short_name: "AL" },
    { label: "ALASKA (AK)", value: "New York", short_name: "AK" },
    { label: "AMERICAN SAMOA (AS)", value: "AMERICAN SAMOA", short_name: "AS" },
    { label: "ARIZONA (AZ)", value: "ARIZONA", short_name: "AZ" },
    { label: "ARKANSAS (AR)", value: "ARKANSAS", short_name: "AR" },
    { label: "CALIFORNIA (CA)", value: "CALIFORNIA", short_name: "CA" },
    { label: "COLORADO (CO)", value: "COLORADO", short_name: "CO" },
    { label: "CONNECTICUT (CT)", value: "CONNECTICUT", short_name: "CT" },
    { label: "DELAWARE (DE)", value: "DELAWARE", short_name: "DE" },
    {
      label: "DISTRICT OF COLUMBIA (DC)",
      value: "DISTRICT OF COLUMBIA",
      short_name: "DC",
    },
    { label: "FLORIDA (FL)", value: "FLORIDA", short_name: "FL" },
    { label: "GEORGIA (GA)", value: "GEORGIA", short_name: "GA" },
    { label: "GUAM (GU)", value: "GUAM", short_name: "GU" },
    { label: "HAWAII (HI)", value: "HAWAII", short_name: "HI" },
    { label: "IDAHO (ID)", value: "IDAHO", short_name: "ID" },
    { label: "ILLINOIS (IL)", value: "ILLINOIS", short_name: "IL" },
    { label: "INDIANA (IN)", value: "INDIANA", short_name: "IN" },
    { label: "IOWA (IA)", value: "IOWA", short_name: "IA" },
    { label: "KANSAS (KS)", value: "KANSAS", short_name: "KS" },
    { label: "KENTUCKY (KY)", value: "KENTUCKY", short_name: "KY" },
    { label: "LOUISIANA (LA)", value: "LOUISIANA", short_name: "LA" },
    { label: "MAINE (ME)", value: "MAINE", short_name: "ME" },
    { label: "MARYLAND (MD)", value: "MARYLAND", short_name: "MD" },
    { label: "MASSACHUSETTS (MA)", value: "MASSACHUSETTS", short_name: "MA" },
    { label: "MICHIGAN (MI)", value: "MICHIGAN", short_name: "MI" },
    { label: "MINNESOTA (MN)", value: "MINNESOTA", short_name: "MN" },
    { label: "MISSISSIPPI (MS)", value: "MISSISSIPPI", short_name: "MS" },
    { label: "MISSOURI (MO)", value: "MISSOURI", short_name: "MO" },
    { label: "MONTANA (MT)", value: "MONTANA", short_name: "MT" },
    { label: "NEBRASKA (NE)", value: "NEBRASKA", short_name: "NE" },
    { label: "NEVADA (NV)", value: "NEVADA", short_name: "NV" },
    { label: "NEW HAMPSHIRE (NH)", value: "NEW HAMPSHIRE", short_name: "NH" },
    { label: "NEW JERSEY (NJ)", value: "NEW JERSEY", short_name: "NJ" },
    { label: "NEW MEXICO (NM)", value: "NEW MEXICO", short_name: "NM" },
    { label: "NEW YORK (NY)", value: "NEW YORK", short_name: "NY" },
    { label: "NORTH CAROLINA (NC)", value: "NORTH CAROLINA", short_name: "NC" },
    { label: "NORTH DAKOTA (ND)", value: "NORTH DAKOTA", short_name: "ND" },
    {
      label: "NORTHERN MARIANA IS (MP)",
      value: "NORTHERN MARIANA IS",
      short_name: "MP",
    },
    { label: "OHIO (OH)", value: "OHIO", short_name: "OH" },
    { label: "OKLAHOMA (OK)", value: "OKLAHOMA", short_name: "OK" },
    { label: "OREGON (OR)", value: "OREGON", short_name: "OR" },
    { label: "PENNSYLVANIA (PA)", value: "PENNSYLVANIA", short_name: "PA" },
    { label: "PUERTO RICO (PR)", value: "PUERTO RICO", short_name: "PR" },
    { label: "RHODE ISLAND (RI)", value: "RHODE ISLAND", short_name: "RI" },
    { label: "SOUTH CAROLINA (SC)", value: "SOUTH CAROLINA", short_name: "SC" },
    { label: "SOUTH DAKOTA (SD)", value: "SOUTH DAKOTA", short_name: "SD" },
    { label: "TENNESSEE (TN)", value: "TENNESSEE", short_name: "TN" },
    { label: "TEXAS (TX)", value: "TEXAS", short_name: "TX" },
    { label: "UTAH (UT)", value: "UTAH", short_name: "UT" },
    { label: "VERMONT (VT)", value: "VERMONT", short_name: "VT" },
    { label: "VIRGINIA (VA)", value: "VIRGINIA", short_name: "VA" },
    { label: "VIRGIN ISLANDS (VI)", value: "VIRGIN ISLANDS", short_name: "VI" },
    { label: "WASHINGTON (WA)", value: "WASHINGTON", short_name: "WA" },
    { label: "WEST VIRGINIA (WV)", value: "WEST VIRGINIA", short_name: "WV" },
    { label: "WISCONSIN (WI)", value: "WISCONSIN", short_name: "WI" },
    { label: "WYOMING (WY)", value: "WYOMING", short_name: "WY" },
  ];

  const columns = [
    // {
    //   name: "Customer ID",
    //   selector: "customer_id",
    //   sortable: true,
    //   // cell: row => <div style={{fontSize: 20}}>{row.firstName}</div>
    // },
    {
      name: "Make and Model",
      selector: "make_model",
      // sortable: true,
    },
    {
      name: "Colour",
      selector: "color",
      // sortable: true,
    },
    {
      name: "License Plate",
      selector: "license_plate",
    },

    {
      name: "State",
      selector: "state",
    },
    // {
    //   name: "Parking Spot",
    //   selector: "parking_spot",
    // },
    // {
    //   name: "Company",
    //   selector: "company",
    // },

    {
      name: "Edit",
      selector: (row) => (
        <div>
          <a
            href="#"
            onClick={(e) => {
              console.log("this row = ", row);
              handleEdit(row);
            }}
          >
            <EditIcon />
          </a>
        </div>
      ),
    },

    {
      name: "Delete",
      cell: (row) => (
        <div>
          <a
            href="#"
            onClick={(e) => {
              handlevehicleDelete(row);
            }}
            className="text-danger"
            data-toggle="modal"
          >
            <DeleteOutlineIcon />
          </a>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (customer_id) {
      console.log("------>>---custid---------->>--", customer_id);
      get(`list_vehicledata`, { params: { id: customer_id } }).then((res) => {
        if (res.status === 200) {
          const data = res;
          // console.log("==",data.data);
          setDatas(data.data);
          const list_length = data.data.length;
          // console.log(data.data,"--------------------------list length--------------------->>0000______________......>>>",data.data.length)
          if (list_length >= 0) {
            setexistingVehicle(list_length);
            // console.log("-----------------      --------------",existing_vehicle)

            const nof_col =
              parseInt(no_vehicle, 10) - parseInt(list_length, 10); // in use
            // console.log("----------------------------------------------->>0000______________......>>>",nof_col)
            setCapacityVehicle(nof_col);
            // console.log("------------------kappacity--------->><<-----------------------",nof_col)
            const my_array = Array.from({ length: nof_col }, () => ({
              make: "",
              model: "",
              license_plate: "",
              color: "",
              state: "TX",
            }));
            setFormData(my_array);
            // console.log(nof_col)
          }
        }
      });
    }
  }, [customer_id, capacity_vehicle, isSubmitted, show]);

  // useEffect(() => {
  //   if(customer_id){
  //   console.log("------>>---custid---------->>--",customer_id)
  //   get(`vehicle_count`,{params :{customer_id:customer_id}}).then((res) => {
  //     const data = res;
  //     console.log("==trtr--------------->",data.data);
  //     // setCapacityVehicle(data.additional_vehicles)

  //   });}

  // }, [customer_id]);

  // const [formData, setFormData] = useState(
  //   Array.from({ length: capacity_vehicle +1 },() => ({
  //     car_name: '',
  //     license_plate: '',
  //     color: '',
  //     state: 'TX',
  //   }))
  // );

  const handleClose = () => setShow(false);

  const handleReassignRfid = async (event) => {
    event.preventDefault();

    try {
      if (
        !rfidDetails?.customer_id ||
        rfidDetails?.tp_credentialid === undefined ||
        !rfidDetails?.tp_id
      ) {
        throw new Error("Missing required RFID details.");
      }

      const payload = {
        customer_id: rfidDetails.customer_id,
        tp_credentialid: rfidDetails.tp_credentialid,
        rfid,
        tp_id: rfidDetails.tp_id,
      };

      console.log("Payload for deletion:", payload);

      const deleteResponse = await remove("delete_rfiddetails", payload);

      if (deleteResponse.status !== 200) {
        throw new Error("Failed to delete RFID details.");
      }

      // RFID successfully deleted, proceed with reassignment
      toast.success("RFID reassigned successfully!");
      setrfidCheckModal(false);
      setRfidDetails({});

      // Handle additional updates
      // if (vehicle === "") {
      //   setVehicle("0");
      // }

      // if (!validateMobileNumber(mobile)) {
      //   setMobile("");
      // }
      let data = {
        firstName: name,
        lastName: lastName,
        admin_id: admin_id,
        email: email,
        mobile: phone,
        account: account,
        vehicles: no_vehicle,
        customer_id: customer_id,
        company: company,
        profile: profile,
        rfid: rfid,
        building: building,
        facilitycode: facilityCode,
        cardId: cardId,
        regdate: regdate,
        room: selectedOptions,
        garage: garage,
        accessgroup: selectedAccessgroups,
        tp_id: tp_id,
        tp_credentialid: tp_credentialid,
        tp_groupid: tp_groupid,
      };

      try {
        const response = await post("edit_customerdata", data);

        // Close the modal before navigating
        if (response?.data?.status === 200) {
          console.log("---------Onclose-----------");
          toast.success("Customer data updated successfully!");

          // Ensure modal closes before navigation
          onClose; // Close modal
          console.log("---------Onclose-----------");
          setTimeout(() => {
            navigate("/dashboard");
          }, 500);
        } else {
          throw new Error("Failed to update customer data");
        }

        // if (response.data.message) {
        //   setTimeout(() => {
        //     toast.success(response.data.message, { autoClose: 500 });
        //   }, 500);
        // } else {
        //   toast.error("Failed to Edit Customer");
        // }
      } catch (error) {
        console.error("Error updating customer data:", error);
        toast.error(
          error.response?.data?.message || "Failed to update customer data"
        );
      }
    } catch (error) {
      console.error("Error in handleReassignRfid:", error);
      toast.error(error.message || "An error occurred while reassigning RFID.");
    } finally {
      setIsLoading(false);
      console.log("---------sd-----------");
    }
  };

  const handleChooseNewRfid = () => {
    console.log("Choosing a new RFID...");
    setrfidCheckModal(false); // Close modal after action
  };

  const handleEdit = (row) => {
    setRowData(row);
    setShow(true);
    // console.log("+  ------------    +", rowData);
  };

  const handleMultiAccessgrp = (selected) => {
    const temp_access_grp = selected;
    // console.log("----------tempACcess ---",temp_access_grp)
    if (!temp_access_grp.some((option) => option.label === "Nimble")) {
      setSelectedOptions("");
    }
    setAccessGroup(selected);
    setSelectedAccessGroups(selected);
  };

  const handlevehicleDelete = (row) => {
    let ur = "delete_vehicledata";
    let url = ur.concat(String(row.vehicle_id));
    let pass_data = {
      vehicle_id: row.vehicle_id,
      admin_id: admin_id,
    };
    post(ur, pass_data).then((response) => {
      if (response.status == 200) {
        console.log("responselogin", response);
        // alert("Deleted", row.customer_id);
        toast.error(`Deleted Sucessfully `, {
          autoClose: 500,
        });
        setIsSubmitted(!isSubmitted);
      } else {
        toast.error(`Error `, {
          autoClose: 500,
        });
      }
      // setTimeout(() => {

      // }, 2000);
    });
  };

  const handleChange = (selected) => {
    console.log(selected);
    // debugger;
    // setItemsnew(selected.map(({ label, index }) => ({ selected: label })));
    setSelectedOptions(selected);
    // console.log("Theese aae selecedd ---- > ",selected)
    // console.log("-------access ---grp ----->",accessGroup)
  };

  const handleChangeveh = (index, e) => {
    const { name, value } = e.target;
    if (name === "license_plate") {
      const hasWhitespace = /\s/.test(value);
      const normalized = value.replace(/\s+/g, "");
      setLicensePlateSpaceError((prev) => ({ ...prev, [index]: hasWhitespace }));
      setFormData((prevData) => {
        const newData = [...prevData];
        newData[index] = { ...newData[index], [name]: normalized };
        return newData;
      });
      return;
    }
    setFormData((prevData) => {
      const newData = [...prevData];
      newData[index] = { ...newData[index], [name]: value };
      return newData;
    });
  };
  const handleLicensePlateKeyDown = (index, e) => {
    if (e.key === " ") {
      e.preventDefault();
      setLicensePlateSpaceError((prev) => ({ ...prev, [index]: true }));
    }
  };

  const handleStateUpdate = (newValue) => {
    setAddOPtion(!addoption);
    return addoption;
  };

  const handleAccessGrpChange = (e) => {
    const accessgrp = e.target.value;
    if (accessgrp !== "Nimble") {
      setSelectedOptions("");
    }
    setAccessGroup(accessgrp);
  };

  // ---------------------

  const handleNameChange = (e) => {
    const enteredValue = e.target.value;
    const alphabeticRegex = /^[A-Za-z\s]+$/;
    if (alphabeticRegex.test(enteredValue) || e.target.value === "") {
      // setFirstName(enteredValue);
      setName(enteredValue);
      // setFirstNameErr(false);
      console.log();
    } else {
      // setFirstNameErr(true);
      // Show tooltip or display an error message
      console.log("Please enter alphabetic characters only");
    }
  };
  const normalizeInput = (value, previousValue) => {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue;
      if (cvLength < 7)
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`;
    }
  };
  const validateMobileNumber = (mobileNumber) => {
    const regex = /^\d{1,10}$/;
    return regex.test(mobileNumber);
  };
  // const filtered = options.filter((employee) => {
  //   return employee.label === "Rm.347";
  // });
  function formatPhoneNumber(input) {
    //  if the input is null, return a null value
    if (!input) return input;
    // remove all characters from the input except number input.
    const numberInput = input.replace(/[^\d]/g, "");
    console.log(numberInput);
    //  take the length of the value of the input
    const numberInputLength = numberInput.length;
    console.log(numberInputLength);
    // if the number length is 1, 2, or 3, then return it as it is.
    if (numberInputLength < 4) {
      return numberInput;
    } else if (numberInputLength < 7) {
      // if the number input length is 4, 5, or 6, format it accordingly.
      return `(${numberInput.slice(0, 3)}) ${numberInput.slice(3)}`;
    } else if (numberInputLength >= 7) {
      //  if the number input length is 7, 8, 9, 10, or more, format it like the below.

      return `(${numberInput.slice(0, 3)}) ${numberInput.slice(
        3,
        6
      )}-${numberInput.slice(6, 10)}`;
    }
    // return empty string in case any condition doesn't satisfy.
    return "";
  }
  const handlemobileChange = (e) => {
    // const enteredValue = e.target.value;
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    //  set the formatted phone number to the input value

    setPhone(formattedPhoneNumber);
  };

  //----------------------

  const handlefacilityChange = (e) => {
    const newFacilityCode = e.target.value;
    if (newFacilityCode <= 255) {
      setfacilityCode(newFacilityCode);
      const rfidcombined = newFacilityCode.concat(":").concat(cardId);
      setRfid(rfidcombined);
    } else {
      toast.error("Error .. Facillity code must be 0 - 255 range", {
        autoClose: 3000,
      });
    }
  };

  const handleCardIdChange = (e) => {
    const newCardId = e.target.value;
    if (newCardId <= 65535) {
      setcardId(newCardId);
      const rfidcombined = facilityCode.concat(":").concat(newCardId);
      setRfid(rfidcombined);
    } else {
      toast.error("Error .. Card Id must be 0 - 65535 range", {
        autoClose: 3000,
      });
    }
  };

  // const handleChangemulti = (selected) => {
  //   console.log("selected", selected);

  //   // setItemsnew(selected.map(({ label, index }) => ({ selected: label })));
  //   setSelectedOptions(selected);
  //   setRooms(selected);
  // };
  function checkPropertiesPresent(item) {
    return (
      item.color && item.make && item.model && item.license_plate && item.state
    );
  }

  function handleSetVehicle(e) {
    // replace no_of vehicle
    const new_val = e.target.value;
    console.log(
      "---------------------count----------------------------------",
      existing_vehicle
    );
    if (new_val - existing_vehicle < 0) {
      const n_cap = existing_vehicle;
      console.log("-------------sd------------------------------->".n_cap);
      setVehicle(n_cap);
      setCapacityVehicle(n_cap);
      return;
    }
    setVehicle(new_val);
    const n_capacity = new_val - existing_vehicle;
    // calculate new capacity
    if (n_capacity >= 0) {
      // console.log("vehicle set------------------------------f----------->>>>",n_capacity)
      setCapacityVehicle(n_capacity);
    } else {
      setCapacityVehicle(n_capacity);
    }
  }

  function handleVehicleSubmitt() {
    // Filter valid items first
    const filteredList = formData.filter(checkPropertiesPresent);

    if (filteredList.length === 0) {
      toast.error(
        "Please provide all required fields (Make, Model, Color, License Plate, State)",
        {
          autoClose: 3000,
        }
      );
      return;
    }

    // Use shared helper to build payload
    const { error, payload } = buildVehiclePayload({
      customer_id: customer_id,
      company: company,
      admin_id: admin_id,
      vehicles: filteredList,
    });

    if (error) {
      // Show field-level errors
      const errorMessages = Object.values(error).flatMap((err) =>
        Object.values(err)
      );
      toast.error(`Validation failed: ${errorMessages.join(", ")}`, {
        autoClose: 3000,
      });
      return;
    }
setIsVehicleLoading(true);
    // Log payload for verification
    console.log(
      "[Flow 2 - Edit Customer] Vehicle payload:",
      JSON.stringify(payload, null, 2)
    );
    setIsVehicleLoading(true);
    // Post call
    post("insert_vehicledata", payload).then(
      (response) => {
        setIsVehicleLoading(false);
        if (response.status === 200) {
          setIsSubmitted(!isSubmitted);
          toast.success(response.data.message);
          const resetList = formData.map((item) => ({
            make: "",
            model: "",
            license_plate: "",
            color: "",
            state: "TX",
          }));
          setFormData(resetList);
          setTimeout(() => {
            // Code to execute after 2 seconds
            console.log("Timer finished!");

            // navigate(-1)
          }, 2000);
        } else {
          const resetList = formData.map((item) => ({
            make: "",
            model: "",
            license_plate: "",
            color: "",
            state: "TX",
          }));
          setFormData(resetList);
          toast.error(`Failed to add vehicle`);
        }
      },
      (error) => {
        const resetList = formData.map((item) => ({
          make: "",
          model: "",
          license_plate: "",
          color: "",
          state: "TX",
        }));
        setFormData(resetList);
        toast.error(error.response?.data?.permit_response?.error?.message || "Failed to add vehicle", {
          autoClose: 3000,
        });
        setIsVehicleLoading(false);
        
      }
    );
  }

  const buttonStyle = {
    fontSize: "0.875rem", // Adjust button text size
    padding: "6px 12px", // Adjust button padding for smaller size
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    // padding: '12px 12px',
    borderRadius: "10px",
    bgcolor: "background.paper",
    boxShadow: 24,
  };

  const handleRfidCheckModalClose = () => {
    setrfidCheckModal(false);
  };
  async function handleSubmit(event) {
    event.preventDefault();
    const isRfidnonEmpty = rfid && rfid.replace(":", "").trim().length > 0;
    const isVehicleZero = no_vehicle === "0" || no_vehicle === "";

    // Show popup if if there is an RFID but 0 vehicles
    if (isRfidnonEmpty && isVehicleZero) {
      setRfidWarningModal(true);
      setRequiresGarageAccess(true);
    } else {
      executeSubmit();
    }
  }
  const executeSubmit = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    console.log();
    let data = {
      firstName: name,
      lastName: lastName,
      admin_id: admin_id,
      email: email,
      mobile: phone,
      account: account,
      vehicles: no_vehicle,
      customer_id: customer_id,
      company: company,
      profile: profile,
      rfid: rfid,
      building: building,
      facilitycode: facilityCode,
      cardId: cardId,
      regdate: regdate,
      room: selectedOptions,
      garage: garage,
      accessgroup: selectedAccessgroups,
      tp_id: tp_id,
      tp_credentialid: tp_credentialid,
      tp_groupid: tp_groupid,
      requires_garage_access: requiresGarageAccess,
    };

    try {
      const response = await post("edit_customerdata", data);

      console.log("data", response.data.message);
      if (response.data.message) {
        setTimeout(() => {
          toast.success(response.data.message, { autoClose: 500 });
          onClose();
        }, 500);
      } else {
        toast.error("Failed to Edit Customer");
      }
    } catch (error) {
      setIsLoading(false); // Stop loading state

      if (error.response?.status === 409) {
        console.log("Conflict detected. Fetching RFID details...");
        setIsLoading(true);

        try {
          const { data, status } = await get(
            `fetch_rfiddetails?rfid=${rfid}&email=${email}`
          );

          if (status === 200) {
            console.log("RFID details fetched:", data);
            setRfidDetails(data);
            setrfidCheckModal(true); // Open modal
            onClose();
            console.log("aaaaaaaaaaaaaaaaa");
          } else {
            toast.error("Failed to fetch RFID details");
          }
        } catch (fetchError) {
          console.error("Error fetching RFID details:", fetchError);
          toast.error("Error fetching RFID details", { autoClose: 3000 });
        }

        setIsLoading(false);
      } else if (error.response?.status === 408) {
        console.log("Request Timeout. Please try again.");
        toast.error("Request timed out. Please try again.", {
          autoClose: 3000,
        });
      } else {
        toast.error(error.response?.data?.message || "Error occurred", {
          autoClose: 3000,
        });
      }
    } finally {
      setIsLoading(false); // Ensure loading stops after everything
    }
  };

  return (
    <>
      {isLoading ? (
        <div
          className="table-style"
          style={{ marginLeft: "45%", marginTop: "20%" }}
        >
          <PulseLoader
            color="#02487B"
            height={29}
            margin={4}
            radius={24}
            width={4}
          />
          <p style={{ fontWeight: "bold", color: "#02487B" }}> Please Wait</p>
        </div>
      ) : (
        <Box
          component="div"
          sx={{
            "& .MuiTextField-root": { m: 0.5, width: "30ch" },
          }}
          noValidate
          autoComplete="off"
          className="mt-5 form-width"
        >
          <form onSubmit={handleSubmit}>
            <div>
              <h3 className="heading-style mb-4">Customer Info</h3>

              <TextField
                type="text"
                color="secondary"
                className="mb-3"
                disabled={disablemode}
                required
                id="outlined-required"
                label="First Name"
                value={name}
                onChange={handleNameChange}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                type="text"
                disabled={disablemode}
                color="secondary"
                className="mb-3"
                id="outlined"
                label="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                type="text"
                color="secondary"
                className="mb-3"
                disabled
                id="outlined-disabled"
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                type="text"
                color="secondary"
                className="mb-3"
                id="outlined"
                disabled={disablemode}
                // label="Mobile No"
                value={phone}
                onChange={handlemobileChange}
                InputProps={{
                  readOnly: false,
                }}
                placeholder="(xxx) xxx-xxxx"
                // inputProps={{
                //   maxLength: 10,
                //   minLength: 10,
                // }}
                variant="outlined"
              />

              <TextField
                disabled
                type="text"
                variant="outlined"
                color="secondary"
                label="Registration Date"
                onChange={(e) => setRegdate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                value={regdate}
                fullWidth
                // required
                sx={{ mb: 2 }}
              />

              <TextField
                type="text"
                color="secondary"
                className="mb-3"
                //  disabled={disablemode}
                id="outlined-number"
                label="Account"
                value={account || ""}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  min: 0,
                  max: 150,
                  step: 1,
                }}
                variant="outlined"
              />

              <TextField
                // type="text"
                variant="outlined"
                color="secondary"
                disabled={disablemode}
                label="Parking Profile"
                onChange={(e) => setProfile(e.target.value)}
                value={profile}
                fullWidth
                required
                select
                className="mb-3"
                InputLabelProps={{ shrink: true }}
                SelectProps={{ native: true }}
                sx={{ mb: 2 }}
              >
                <option key="vdsgh65" value="">
                  {" "}
                  Please select{" "}
                </option>
                <option key="bt6g5g8" value="All Access">
                  All Access{" "}
                </option>
                <option key="lkjyub1" value="Level 1">
                  {" "}
                  Level 1{" "}
                </option>
                <option key="lkjyub" value="Level 2">
                  {" "}
                  Level 2{" "}
                </option>
                <option key="lkjyub3" value="Level 3">
                  {" "}
                  Level 3{" "}
                </option>
                <option key="lkjyub4" value="Level 4">
                  {" "}
                  Level 4{" "}
                </option>
                <option key="lkjyub5" value="Level 5">
                  {" "}
                  Level 5{" "}
                </option>
                <option key="lkhddb" value="GP">
                  {" "}
                  GP{" "}
                </option>
                {/* <option key='anvtre' value='Flash Test'> Flash Test </option> */}
              </TextField>

              <TextField
                type="text"
                select
                variant="outlined"
                disabled={disablemode}
                color="secondary"
                label="No Of Vehicles"
                onChange={handleSetVehicle}
                value={no_vehicle}
                fullWidth
                InputLabelProps={{ shrink: true }}
                SelectProps={{ native: true }}
                required
                className="mb-3"
                sx={{ mb: 2 }}
              >
                <option key="kfdrjh6" value="0">
                  {" "}
                  0{" "}
                </option>
                <option key="45dsf4h" value="1">
                  {" "}
                  1{" "}
                </option>
                <option key="fghghygh" value="2">
                  {" "}
                  2{" "}
                </option>
                <option key="sd4fg7" value="3">
                  {" "}
                  3{" "}
                </option>
                {/* <option key='3454fgb' value='4'>  4 </option> */}
              </TextField>

              {/* <Stack spacing={2} direction="row" sx={{marginBottom: 2}}> */}

              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                disabled={disablemode}
                label="Facility Code"
                onChange={handlefacilityChange}
                value={facilityCode}
                className="mb-3"
              />

              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                disabled={disablemode}
                label=" Card Id"
                onChange={handleCardIdChange}
                value={cardId}
                className="mb-3"
              />
              {/* </Stack> */}

              <TextField
                type="text"
                disabled
                variant="outlined"
                color="secondary"
                label="RFID"
                // onChange={handleNameChange}
                value={rfid}
                className="mb-3"
              />

              <TextField
                className="mb-3"
                disabled={localStorage.getItem("company") === 0 ? true : false}
                label="Select Company"
                name="name"
                onChange={(e) => setCompany(e.target.value)}
                required
                select
                value={company}
                InputLabelProps={{ shrink: true }}
                SelectProps={{ native: true }}
                sx={{ mb: 2 }}
                //   value={values.state}
              >
                {/* <option key="" value="">
                {" "}
                {company}
              </option> */}
                {companyList.map((company) => (
                  <option key={company} value={company}>
                    {company}
                  </option>
                ))}
              </TextField>

              <TextField
                type="text"
                select
                disabled={disablemode}
                variant="outlined"
                color="secondary"
                label="Building"
                onChange={(e) => setBuilding(e.target.value)}
                value={building}
                className="mb-3"
                InputLabelProps={{ shrink: true }}
                SelectProps={{ native: true }}
                required
                sx={{ mb: 2 }}
              >
                <option key="bv" value="250  Assay Street">
                  {" "}
                  250 Assay Street
                </option>
              </TextField>

              <TextField
                type="text"
                select
                disabled={disablemode}
                variant="outlined"
                color="secondary"
                label="Garage Address"
                // onChange={e => setVehicle(e.target.value)}
                value={garage}
                className="mb-3"
                InputLabelProps={{ shrink: true }}
                SelectProps={{ native: true }}
                required
                sx={{ mb: 2 }}
              >
                <option key="ga1" value="Garage Address">
                  {" "}
                  707 Redemption
                </option>
              </TextField>

              <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
                {/* <TextField
                // type="text"
                variant="outlined"
                color="secondary"
                disabled={disablemode}
                label="Building Access Group"
                onChange={handleAccessGrpChange}
                value={accessGroup}
                className="mb-3"
                required
                select
                InputLabelProps={{ shrink: true }}
                SelectProps={{ native: true }}
                sx={{ mb: 2 }}
              >
                {" "}
                <option key="kdjs7" value="Admin">
                  {" "}
                  Admin{" "}
                </option>
                <option key="All Access" value="All Access">
                  {" "}
                  All Access{" "}
                </option>
                <option key="mens" value="Men's Room">
                  {" "}
                  Men's Room
                </option>
                <option key="womenns" value="Women's Room">
                  Women's Room{" "}
                </option>
                <option key="suit" value="Suit 301">
                  Suit 301{" "}
                </option>
                <option key="trash" value="Trash Rm">
                  Trash Rm{" "}
                </option>
                <option key="h3j" value="Apache">
                  {" "}
                  Apache{" "}
                </option>
                <option key="g3" value="Caprock">
                  {" "}
                  Caprock{" "}
                </option>
                <option key="g3f45" value="McCord">
                    {" "}
                    McCord{" "}
                  </option>
                <option key="g65" value="Nimble">
                  Nimble{" "}
                </option>
              </TextField> */}

                <div className="dropdown-container">
                  <Select
                    options={access_group_options}
                    placeholder="Select"
                    value={selectedAccessgroups}
                    onChange={handleMultiAccessgrp}
                    isSearchable={true}
                    isMulti
                  />
                </div>

                {/* {accessGroup === "Nimble" ? (
              
                <div className="dropdownsize">
                  <MultiSelect
                    options={options}
                    value={selectedOptions}
                    onChange={setSelectedOptions}
                    labelledBy={"Select"}
                    isCreatable={true}
                  />
                 
                </div>
              ) : (
                ""
              )} */}

                {selectedAccessgroups.some(
                  (option) => option.label === "Nimble"
                ) ? (
                  // This block will be rendered when "Nimble" exists in access_group_options
                  <div className="dropdown-container">
                    <Select
                      options={options}
                      placeholder="Select"
                      value={selectedOptions}
                      onChange={handleChange}
                      isSearchable={true}
                      isMulti
                    />
                  </div>
                ) : // This block will be rendered when "Nimble" does not exist in access_group_options
                // You can put other JSX components here or leave it empty
                null}
              </Stack>
              {/* ------- */}
            </div>
            <div className="text-end w-100 mt-1">
              <input
                type="submit"
                value="Update"
                disabled={disablemode}
                className="mb-4 btn btn-primary btn-sty"
              />
            </div>

            <br />
          </form>
        </Box>
      )}
      <Box
        component="div"
        sx={{
          "& .MuiTextField-root": { m: 0.5, width: "30ch" },
        }}
        noValidate
        autoComplete="off"
        className="mt-5 form-width"
      >
        <h3 className="heading-style">Vehicle Details</h3>

        <DataTable
          title=""
          columns={columns}
          data={datas}
          highlightOnHover
          customTheme={myNewTheme}
          // pagination
          // paginationPerPage={5}
          // paginationRowsPerPageOptions={[5, 15, 25, 50]}
          // paginationComponentOptions={{
          //   rowsPerPageText: "Records per page:",
          //   rangeSeparatorText: "out of",
          // }}
          className="table-style"
        />
      </Box>
      {capacity_vehicle > 0 && (
        <Box
          component="div"
          sx={{
            "& .MuiTextField-root": { m: 0.5, width: "30ch" },
          }}
          noValidate
          autoComplete="off"
          className="mt-5 form-width"
        >
          <div>
            <h3 className="heading-style mb-4">Add Vehicle Details</h3>
            {isVehicleLoading ? (
              /* Using your project's specific loader style */
              <div className="text-center" style={{ padding: "40px" }}>
                <PulseLoader
                  color="#02487B"
                  height={29}
                  margin={4}
                  radius={24}
                  width={4}
                />
                <p
                  style={{
                    fontWeight: "bold",
                    color: "#02487B",
                    marginTop: "10px",
                  }}
                >
                  Adding Vehicle Details...
                </p>
              </div>
            ) : (
              <form
                onSubmit={handleVehicleSubmitt}
                action={<Link to="/login" />}
              >
                {/* <br />  */}
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{ marginBottom: 2 }}
                  className="mb-0"
                >
                  {" "}
                </Stack>

                {capacity_vehicle > 0 && (
                  <>
                    {/* <br /> */}

                    {formData.map((data, index) => (
                      <div key={index}>
                        <Stack
                          spacing={4}
                          direction="row"
                          sx={{ marginBottom: 2 }}
                          className="mb-0"
                        >
                          <TextField
                            type="text"
                            variant="outlined"
                            color="secondary"
                            label={`Make ${index + 1}`}
                            name="make"
                            required
                            value={data.make}
                            onChange={(e) => handleChangeveh(index, e)}
                            fullWidth
                            sx={{ mb: 2 }}
                          />
                          <TextField
                            type="text"
                            variant="outlined"
                            color="secondary"
                            label={`Model ${index + 1}`}
                            name="model"
                            required
                            value={data.model}
                            onChange={(e) => handleChangeveh(index, e)}
                            fullWidth
                            sx={{ mb: 2 }}
                          />
                          <TextField
                            type="text"
                            variant="outlined"
                            color="secondary"
                            label={`Colour ${index + 1}`}
                            name="color"
                            required
                            value={data.color}
                            onChange={(e) => handleChangeveh(index, e)}
                            fullWidth
                            sx={{ mb: 2 }}
                          />

                          <TextField
                            type="text"
                            variant="outlined"
                            color="secondary"
                            label={`License Plate ${index + 1}`}
                            name="license_plate"
                            required
                            value={data.license_plate}
                            onChange={(e) => handleChangeveh(index, e)}
                            onKeyDown={(e) =>
                              handleLicensePlateKeyDown(index, e)
                            }
                            error={Boolean(licensePlateSpaceError[index])}
                            helperText={
                              licensePlateSpaceError[index]
                                ? "Spaces are not allowed in License Plate."
                                : ""
                            }
                            fullWidth
                            sx={{ mb: 2 }}
                          />

                          <TextField
                            fullWidth
                            label={`Select State ${index + 1}`}
                            name="state"
                            onChange={(e) => handleChangeveh(index, e)}
                            select
                            required
                            value={data.state}
                            InputLabelProps={{ shrink: true }}
                            SelectProps={{ native: true }}
                            sx={{ mb: 2 }}
                          >
                            <option key="0" value="">
                              Please select
                            </option>
                            {states.map((option) => (
                              <option
                                key={option.value}
                                value={option.short_name}
                              >
                                {option.short_name}
                              </option>
                            ))}
                          </TextField>
                        </Stack>
                      </div>
                    ))}

                    <br />
                    {/* <div className="text-end w-100 mt-1">
            <input
              type="submit"
              value="ADD"
              disabled={disablemode}
              className="mb-4 btn btn-primary btn-sty"
              onClick={handleVehicleSubmitt}
            />
          </div> */}
                    <div className="text-end">
                      <Button
                        // type="submit"
                        sx={{ backgroundColor: "#0d6efd" }}
                        variant="contained"
                        // color="primary"
                        onClick={handleVehicleSubmitt}
                        size="large"
                        className=" btn-sty btn btn-primary text-capitalize"
                        style={{ padding: "6px" }}
                      >
                        Add
                      </Button>
                    </div>
                    <br />
                  </>
                )}

                {/* {hideCancel || !open && (<>
          <div className="text-end">  <Button variant="outlined" color="error"  onClick={handleCancel} size="large" className=" btn-sty">Cancel</Button></div> </>)} */}
              </form>
            )}
          </div>
        </Box>
      )}
      <div>
        <BootstrapDialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          // className="m-0 w-100"
          maxWidth={"lg"}
          // fullScreen
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            className="heading-style bg-gray"
            onClose={handleClose}
          >
            {"Edit Vehicle"}
          </BootstrapDialogTitle>
          <DialogContent>
            <EditvehicleForm
              vehicle_form_data={rowData}
              // onClose={handleClose}
              onClosetab={handleClose}
            />
          </DialogContent>
        </BootstrapDialog>
      </div>
      <br /> <br /> <br />
      <Modal
        open={rfidCheckModal}
        onClose={handleRfidCheckModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              padding: "15px",
              position: "relative",
              width: "100%",
            }}
          >
            <div className="warning-position">
              <img
                src={WarningIcon}
                alt=""
                className=""
                style={{ width: "70px" }}
              />
            </div>

            <IconButton size="small" onClick={handleRfidCheckModalClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className="modal-wrapper">
            <div className="important-msg">
              <p>
                This RFID is already Assigned to{" "}
                <b>
                  {" "}
                  {rfidDetails?.first_name} {rfidDetails?.last_name},{" "}
                  {rfidDetails?.email}{" "}
                </b>{" "}
                <br />
                (Status: {rfidDetails?.status})
              </p>
            </div>
            <p
              style={{ color: "#00000080", fontSize: "18px" }}
              className="mt-4"
            >
              Please verify the details before proceeding.
            </p>
            <div className="btn-section-modal">
              <Button
                variant="contained"
                color="primary"
                size="large"
                className="me-4 btn-sty w-100 rfid-btn"
                sx={{ mr: 2, ...buttonStyle }}
                onClick={handleReassignRfid} // Define this function in your component
              >
                Reassign the RFID
              </Button>

              <Button
                variant="outlined"
                color="secondary"
                size="large"
                className="btn-sty w-100 rfid-btn second"
                sx={buttonStyle}
                onClick={handleChooseNewRfid} // Define this function in your component
              >
                Choose a new RFID
              </Button>
            </div>
            <p className="mb-0 notes">
              Note: Reassigning the RFID will delete the RFID record of existing
              user.
            </p>
            <p className="mb-0 notes">
              Choose a new RFID if you want to assign a different RFID to this
              user.
            </p>
          </div>
        </Box>
      </Modal>
      <Modal open={rfidWarningModal} onClose={() => setRfidWarningModal(false)}>
        <Box sx={style}>
          <div style={{ padding: "25px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <img
                src={WarningIcon}
                alt="warning"
                style={{ width: "40px", marginRight: "15px" }}
              />
              <h3 className="heading-style" style={{ margin: 0 }}>
                Garage Access Check
              </h3>
            </div>
            <hr />

            <p style={{ fontSize: "17px", margin: "20px 0" }}>
              {!rfid || rfid === ":"
                ? "No RFID details were provided."
                : "You have assigned an RFID but selected 0 vehicles."}
            </p>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#f5f5f5",
                padding: "15px",
                borderRadius: "8px",
                marginBottom: "25px",
              }}
            >
              <input
                type="checkbox"
                id="garage-check"
                checked={requiresGarageAccess}
                onChange={(e) => setRequiresGarageAccess(e.target.checked)}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
              <label
                htmlFor="garage-check"
                style={{
                  marginLeft: "12px",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                Does this customer require garage access?
              </label>
            </div>

            <div className="text-end">
              <Button
                variant="contained"
                color="primary"
                size="large"
                className="me-3 btn-sty"
                onClick={() => {
                  setRfidWarningModal(false);
                  executeSubmit();
                }}
              >
                Confirm & Save
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                className="btn-sty"
                onClick={() => setRfidWarningModal(false)}
              >
                Go Back
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default CustomerEditforms;
